import { buildMatchCompleteHref } from "../components/Matches/matchesHubNavigation";

/** Trader URL `sport=` slug (cricket, football, tennis, horses). */
export function traderUrlSportParam(sportLower: string): string {
  if (sportLower === "horse" || sportLower === "horses") return "horses";
  if (sportLower === "soccer" || sportLower === "football") return "football";
  return sportLower;
}

function normalizeTraderSportSlug(sportRaw?: string | null): string {
  return traderUrlSportParam(String(sportRaw || "cricket").trim().toLowerCase());
}

export function hasReadableActivityMatchName(
  matchName: string | null | undefined,
  matchId: string
): boolean {
  const name = matchName?.trim() ?? "";
  return name.length > 0 && name !== matchId;
}

/** Sport-specific Trader lobby when fixture/event metadata is unavailable. */
export function traderLobbyHref(sportRaw?: string | null): string {
  return `/trader?sport=${encodeURIComponent(normalizeTraderSportSlug(sportRaw))}`;
}

/** Finished match page when we have a fixture id; otherwise the sport Trader lobby. */
export function traderActivityMatchHref(
  matchId: string,
  _matchName?: string | null,
  sportRaw?: string | null
): string {
  const id = matchId.trim();
  if (id) {
    return buildMatchCompleteHref(id, sportRaw);
  }
  return traderLobbyHref(sportRaw);
}
